import getColor from "@insite/mobius/utilities/getColor";
import widgetModule, { documentsStyles } from "@stoneage/App/Widgets/Documents/Documents";
import { css } from "styled-components";

documentsStyles.widgetContainer = {
    css: css`
        ${documentsStyles.widgetContainer?.css};
        box-shadow: none;
        border: 1px solid ${getColor("common.ui5")};
    `,
};

export * from "@stoneage/App/Widgets/Documents/Documents";
export default widgetModule;
